// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const kapangColors: ColorType = {
  ...colorPalette,
  primary: '#FFFFFF',
  secondary: '#FFFFFF',
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
}

export const darkTheme = {
  colors: kapangColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: kapangColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: kapangColors.primaryGray,
    secondary: kapangColors.secondaryGray,
    disabled: kapangColors.grayText,
    link: kapangColors.secondaryGray,
    hint: kapangColors.white,
    highlight: kapangColors.secondary,
    gray: kapangColors.primaryGray,
    seeAll: kapangColors.secondaryGray,
    primaryContrast: '#000000',
  },
  border: {
    primary: kapangColors.primaryGray,
    gray: kapangColors.secondaryGray,
  },
  filter: {
    primary: kapangColors.primaryGray,
    secondary: kapangColors.secondaryGray,
    disabled: kapangColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: kapangColors.dark,
    color: kapangColors.white,
    border: kapangColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: kapangColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: kapangColors.dark,
        selected: kapangColors.dark,
        progress: rgba(kapangColors.primary, 0.3),
        past: rgba(kapangColors.primary, 0.3),
        pastSelected: kapangColors.dark,
        pastHover: kapangColors.dark,
        empty: '#555555',
        emptyProgress: rgba(kapangColors.primary, 0.1),
      },
      text: {
        empty: kapangColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: kapangColors.white,
    subTitle: kapangColors.secondaryGray,
    bg: kapangColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {},
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
